<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Rough Kapans</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <button @click="open_purchase_modal" class="btn btn-primary shadow-md mr-2"
          v-if="user_details.user_role == 1 || user_details.user_role == 3 || user_details.user_role == 8">Add
          Purchase</button>
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col">
        <div class="grid grid-cols-12 gap-x-2">
          <div class="col-span-6 md:col-span-3 xl:col-span-2">
            <div>
              <label for="update-profile-form-6" class="form-label py-1">Kapan No</label>
              <input id="tabulator-html-filter-value" v-model="filter_data.kapan_no" type="text"
                class="form-control 2xl:w-full mt-2 sm:mt-0" placeholder="Kapan No" />
            </div>
          </div>
          <div class="col-span-6 md:col-span-3 xl:col-span-2" v-if="user_details.user_role != 3">
            <div>
              <label for="update-profile-form-6" class="form-label py-1">Select Vendor</label>
              <TomSelect v-model="filter_data.party_id" :options="{
                placeholder: 'Select Vendor',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Vendor'
                  }
                }
              }" class="w-full">
                <option value="0">Select Vendor</option>
                <option v-for="item in page_data.party_details" :key="item.id" :value="item.id">{{ item.firm_name ?
                  item.firm_name : item.first_name + ' ' + item.last_name }}</option>
              </TomSelect>
            </div>
          </div>
          <div class="col-span-6 md:col-span-3 xl:col-span-2" v-if="user_details.user_role != 3 && settings && settings['PURCHASE_PARTY_VISIBLE'] == 1">
            <div>
              <label for="update-profile-form-6" class="form-label py-1">Select Purchase Party</label>
              <TomSelect v-model="filter_data.purchase_party" :options="{
                placeholder: 'Select Purchase Party',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Purchase Party'
                  }
                }
              }" class="w-full">
                <option value="0">Select Purchase Party</option>
                <option v-for="item in page_data.purchase_party_details" :key="item.id" :value="item.id">
                  {{ item.firm_name ? item.firm_name : item.first_name + ' ' + item.last_name }}</option>
              </TomSelect>
            </div>
          </div>
          <div class="col-span-6 md:col-span-3 xl:col-span-2" v-if="user_details.user_role != 3 && settings && settings['DIAMOND_TYPE_VISIBLE'] == 1">
            <div>
              <label for="update-profile-form-6" class="form-label py-1">Select Diamond Type</label>
              <TomSelect v-model="filter_data.diamond_type" :options="{
                placeholder: 'Select Diamond Type',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Purchase Party'
                  }
                }
              }" class="w-full">
                <option value="0">Select Diamond Type</option>
                <option v-for="item in page_data.diamond_type_items" :key="item.id" :value="item.id">{{ item.type }}
                </option>
              </TomSelect>
            </div>
          </div>
          <div class="col-span-6 md:col-span-3 xl:col-span-2">
            <div>
              <label for="update-profile-form-6" class="form-label py-1">Purchase Type</label>
              <TomSelect v-model="filter_data.type" :options="{
                placeholder: 'Select Purchase Type',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Party'
                  }
                }
              }" class="w-full">
                <option value="0">Select Type</option>
                <option value="makeable">Makeable</option>
                <option value="rough">Rough</option>
              </TomSelect>
            </div>
          </div>
          <div class="col-span-6 md:col-span-3 xl:col-span-2">
            <div>
              <label for="update-profile-form-6" class="form-label py-1">Select Stone</label>
              <TomSelect v-model="filter_data.stone_id" :options="{
                placeholder: 'Select Stone',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Party'
                  }
                }
              }" class="w-full">
                <option value="0">Select Stone</option>
                <option v-for="item in page_data.stones" :key="item.id" :value="item.id">{{ item.stone_name }}</option>
              </TomSelect>
            </div>
          </div>
          <div class="col-span-6 md:col-span-3 xl:col-span-2">
            <div>
              <label for="update-profile-form-6" class="form-label py-1">Status</label>
              <TomSelect v-model="filter_data.status" :options="{
                placeholder: 'Select Status',
                loadingClass: 'loading',
                plugins: {
                  dropdown_header: {
                    title: 'Series'
                  }
                }
              }" class="w-full">
                <option value="0">Select Status</option>
                <option value="stock">In Stock</option>
                <option value="1">Active</option>
                <option value="2">Processing</option>
                <option value="3">Cancelled</option>
                <option value="4">Delivered</option>
              </TomSelect>
            </div>
          </div>
          <div class="col-span-2 md:col-span-2 xl:col-span-1">
            <div class="mt-7 flex pt-2">

              <button id="tabulator-html-filter-reset" type="button"
                class="btn btn-secondary w-full mt-2 sm:mt-0 sm:ml-2" @click="onResetFilter">
                Reset
              </button>
            </div>
          </div>
          <div class="col-span-2 md:col-span-2 xl:col-span-1">
            <div class="mt-7 flex pt-2">

              <button id="tabulator-html-filter-go" type="button" class="btn btn-primary w-full ml-2" tabindex="5"
                @click="initTabulator()">
                Go
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-6 lg:col-span-3 intro-y mt-2">
          <div class="report-box zoom-in">
            <div class="box p-2">
              <div class="flex items-center justify-between">
                <!-- <ActivityIcon class="report-box__icon text-theme-10" /> -->
                <div class="text-base text-gray-600">Total Kapan</div>
                <div class="text-xl font-medium leading-8">{{ page_data.total.total_purchase }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-12 sm:col-span-6 lg:col-span-3 intro-y mt-2">
          <div class="report-box zoom-in">
            <div class="box p-2">
              <div class="flex items-center justify-between">
                <!-- <ActivityIcon class="report-box__icon text-theme-10" /> -->
                <div class="text-base text-gray-600">Total Weight</div>
                <div class="text-xl font-medium leading-8">{{ page_data.total.total_weight ?
                  $h.myFloat(page_data.total.total_weight) + ' ct' : '0.00 ct' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-12 sm:col-span-6 lg:col-span-3 intro-y mt-2">
          <div class="report-box zoom-in">
            <div class="box p-2">
              <div class="flex items-center justify-between">
                <!-- <CheckCircleIcon class="report-box__icon text-theme-11" /> -->
                <div class="text-base text-gray-600">Cr. Weight</div>
                <div class="text-xl font-medium leading-8">{{ page_data.total.total_cr_weight ?
                  $h.myFloat(page_data.total.total_cr_weight) + ' ct' : '0.00 ct' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div id="tabulator" ref="tableRef" class="mt-5 table-report table-report--tabulator"></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->
    <CreatePurchase ref="CreatePurchaseRef" />
    <PurchaseRejection ref="PurchaseRejectionRef" />
    <RoughIssue ref="RoughIssueRef" @refresh-tabulator="initTabulator" />
  </div>
</template>

<script setup>
/* eslint-disable */
import {
  BASE_URL
} from '@/constants/config'
import axios from 'axios'
import cash from 'cash-dom'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import {
  computed,
  inject,
  onMounted,
  reactive,
  ref
} from 'vue'
import {
  helper as $h
} from '@/utils/helper'
// import store from '@/store'
import CreatePurchase from '@/views/Purchase/modals/Create.vue'
import PurchaseRejection from '@/views/Purchase/modals/RejectionForm.vue'
import RoughIssue from '@/views/Purchase/modals/RoughIssue.vue'
import router from '@/router'
import {
  useStore
} from '@/store'

const swal = inject('$swal')
const store = useStore()
const user_details = computed(() => store.state.user.currentUser)
const settings = computed(() => store.state.user.settings)
const tableRef = ref()
const tabulator = ref()

const CreatePurchaseRef = ref();
const PurchaseRejectionRef = ref();
const RoughIssueRef = ref();

const page_data = reactive({
  party_details: [],
  purchase_party_details: [],
  loading: false,
  diamond_type_items: [],
  total: [],
  home_party: ""

})

const filter_data = reactive({
  status: '0',
  kapan_no: '',
  type: '0',
  party_id: '0',
  purchase_party: '0',
  diamond_type: '0',
  stone_id: '0',
})

const pcsFormatter = (value, unit) =>
  `<div class="whitespace-nowrap text-center">${value ? value + ' ' + unit : 'N/A'}</div>`;

const statusFormatter = (cell) => {
  const map = {
    0: ['Active', 'text-theme-9'],
    1: ['Active', 'text-theme-9'],
    2: ['Processing', 'text-theme-9'],
    3: ['Cancelled', 'text-theme-6'],
    4: ['Delivered', 'text-theme-9'],
  };

  const status = map[cell.getData().status];
  if (!status) return '';

  return `
    <div class="flex items-center lg:justify-center ${status[1]}">
      <i data-feather="check-square" class="w-4 h-4 mr-2"></i> ${status[0]}
    </div>`;
};

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

const nowrap = (val) =>
  `<div class="whitespace-nowrap text-center">${val || 'N/A'}</div>`;

const pcsWt = (pcs, wt) =>
  `<div class="whitespace-nowrap text-center">
    ${pcs ? pcs + ' Pcs' : 'N/A'}<br>
    ${wt ? wt + ' Ct' : 'N/A'}
  </div>`;


const initTabulator = () => {
  
  const params = {
    stone_id: (filter_data.stone_id == '0' ? '' : window.btoa(filter_data.stone_id)),
    status: (filter_data.status == '0' ? '' : window.btoa(filter_data.status)),
    kapan_no: (filter_data.kapan_no == '' ? '' : window.btoa(filter_data.kapan_no)),
    employee_id: (filter_data.employee_id == '0' ? '' : window.btoa(filter_data.employee_id)),
    party_id: (filter_data.party_id == '0' ? '' : window.btoa(filter_data.party_id)),
    purchase_party: (filter_data.purchase_party == '0' ? '' : window.btoa(filter_data.purchase_party)),
    diamond_type: (filter_data.diamond_type == '0' ? '' : window.btoa(filter_data.diamond_type)),
    type: (filter_data.type == '0' ? '' : window.btoa(filter_data.type)),
    // issue_date: (filter_data.issue_date == '' ? '' : window.btoa(filter_data.issue_date)),
    // receive_date: (filter_data.receive_date == '' ? '' : window.btoa(filter_data.receive_date)),
  }
  if (user_details.value.user_role == 3) {
    tabulator.value = new Tabulator(tableRef.value, {
      ajaxURL: BASE_URL + 'api/kpn/grpd',
      ajaxParams: params,

      ajaxConfig: {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      },

      ajaxFiltering: true,
      ajaxSorting: true,

      pagination: 'remote',
      paginationSize: 20,
      paginationSizeSelector: [20, 30, 40],

      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',

      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          hozAlign: 'center',
          headerSort: false,
          resizable: false,
        },
        {
          title: 'Lot',
          field: 'lot_no',
          minWidth: 90,
          formatter: 'textarea',
        },
        {
          title: 'KapanNo',
          field: 'voucher_no',
          minWidth: 100,
          hozAlign: 'center',
          formatter: 'textarea',
        },
        {
          title: 'Type',
          field: 'type',
          minWidth: 100,
          hozAlign: 'center',
          formatter: 'textarea',
        },
        {
          title: 'PIECES',
          minWidth: 120,
          hozAlign: 'center',
          formatter: (cell) =>
            pcsFormatter(cell.getData().pr_pcs, 'Pcs'),
        },
        {
          title: 'WEIGHT',
          minWidth: 120,
          hozAlign: 'center',
          formatter: (cell) =>
            pcsFormatter(cell.getData().pr_wt, 'Ct'),
        },
        {
          title: 'Status',
          minWidth: 90,
          formatter: statusFormatter,
        },
        {
          title: 'Date',
          field: 'created_at',
          minWidth: 100,
          formatter: 'textarea',
        },
        {
          title: 'Create IP',
          field: 'issue_trans_ip',
          minWidth: 100,
          hozAlign: 'center',
        },
      ],

      renderComplete() {
        feather.replace({ 'stroke-width': 1.5 });
      },
    });

  } else {
    tabulator.value = new Tabulator(tableRef.value, {
      ajaxURL: BASE_URL + 'api/kpn/grpd',
      ajaxParams: params,

      ajaxConfig: {
        method: 'GET',
        headers: authHeaders(),
      },

      ajaxFiltering: true,
      ajaxSorting: true,

      pagination: 'remote',
      paginationSize: 20,
      paginationSizeSelector: [20, 30, 40],

      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',

      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          hozAlign: 'center',
          headerSort: false,
          resizable: false,
        },

        {
          title: 'Lot',
          field: 'lot_no',
          minWidth: 90,
          formatter: 'textarea',
          cellClick: (_, cell) =>
            router.push(`/purchase/rough/${btoa(cell.getData().id)}`),
        },

        { title: 'KapanNo', field: 'voucher_no', minWidth: 100, hozAlign: 'center', formatter: 'textarea' },
        { title: 'Type', field: 'type', minWidth: 100, hozAlign: 'center', formatter: 'textarea' },

        {
          title: 'Vendor',
          minWidth: 100,
          hozAlign: 'center',
          formatter: (c) =>
            `<div class="whitespace-nowrap">
              ${c.getData().party_firm_name ??
                `${c.getData().party_first_name}<br>${c.getData().party_last_name}`}
            </div>`,
        },
        ...(settings.value?.PURCHASE_PARTY_VISIBLE == 1
        ? [
            {
              title: 'Purchase <br> Party',
              minWidth: 100,
              hozAlign: 'center',
              formatter: (c) =>
                `<div class="whitespace-nowrap">${c.getData().purchase_party_company_name || ''}</div>`,
            },
          ]
        : []),
        ...(settings.value?.DIAMOND_TYPE_VISIBLE == 1
        ? [
            {
          title: 'Diamond <br> Type',
          minWidth: 100,
          hozAlign: 'center',
          formatter: (c) =>
            `<div class="whitespace-nowrap">${c.getData().diamond_type_name || ''}</div>`,
        },
          ]
        : []),

        {
          title: 'O. PCS <br> O. WT',
          minWidth: 120,
          hozAlign: 'center',
          formatter: (c) => pcsWt(c.getData().pr_pcs, c.getData().pr_wt),
        },

        {
          title: 'Cr. PCS <br> Cr. WT',
          minWidth: 120,
          hozAlign: 'center',
          formatter: (c) => pcsWt(c.getData().cr_pcs, c.getData().cr_wt),
        },

        {
          title: 'Proc. PCS <br> Proc. WT',
          minWidth: 120,
          hozAlign: 'center',
          formatter: (c) => pcsWt(c.getData().inpr_pcs, c.getData().inpr_wt),
        },

        {
          title: 'Rej. PCS <br> Rej. WT',
          minWidth: 120,
          hozAlign: 'center',
          formatter: (c) => {
            const pcs = (c.getData().fail_pcs || 0) + (c.getData().rejection_pcs || 0);
            const wt =
              (parseFloat(c.getData().fail_wt) || 0) +
              (parseFloat(c.getData().rejection_wt) || 0);
            return pcsWt(pcs, $h.myFloat(wt));
          },
        },

        {
          title: 'Lose Wt',
          minWidth: 100,
          hozAlign: 'center',
          formatter: (c) => nowrap(c.getData().ghat_wt && c.getData().ghat_wt + ' Ct'),
        },

        {
          title: 'Status',
          minWidth: 90,
          formatter: statusFormatter,
        },

        { title: 'Date', field: 'created_at', minWidth: 100, formatter: 'textarea' },
        { title: 'Create IP', field: 'issue_trans_ip', minWidth: 100, hozAlign: 'center' },

        {
        title: 'Action',
        hozAlign: 'center',
        field: 'status',
        minWidth: 100,
        vertAlign: 'middle',
        print: false,
        responsive: 0,
        download: false,
        formatter(cell) {
          const data = cell.getData();
          const user = user_details.value;

          const canEdit =
            (data.status === 0 || data.status === 1) &&
            data.man_status === 1 &&
            data.hold_transaction_id == null &&
            data.manager_id === user.account_id &&
            data.manager_type === user.user_role;

          const canAddPieces = canEdit && data.pr_status == null;

          // Main dropdown
          const dropdown = document.createElement('div');
          dropdown.className = 'dropdown';

          // Button
          const button = document.createElement('button');
          button.className = 'btn btn-secondary btn-sm dropdown-toggle';
          button.type = 'button';
          button.innerHTML = `Action <i data-feather="chevron-down" class="w-4 h-4 ml-2"></i>`;

          // Menu
          const menu = document.createElement('div');
          menu.className = 'dropdown-menu';

          const content = document.createElement('div');
          content.className = 'dropdown-menu__content box bg-theme-26 dark:bg-dark-6 text-white';

          // Reusable item creator (INLINE)
          const addItem = (text, onClick) => {
            const wrap = document.createElement('div');
            wrap.className = 'p-1 border-t border-theme-27 dark:border-dark-3';

            const item = document.createElement('div');
            item.className =
              'flex items-center block p-2 transition duration-300 ease-in-out rounded-md cursor-pointer hover:bg-theme-1 dark:hover:bg-dark-3';
            item.setAttribute('data-dismiss', 'dropdown');
            item.innerText = text;
            item.addEventListener('click', onClick);

            wrap.appendChild(item);
            content.appendChild(wrap);
          };

          // View
          addItem('View Details', () => {
            router.push('/purchase/rough/' + btoa(data.id));
          });

          if (canEdit) {
            addItem('Edit Details', () => {
              CreatePurchaseRef.value.get_purchase_data(data.id);
            });

            addItem('Cancel Purchase', () => {
              cancel_process(data.id);
            });

            addItem('Reject Weight', () => {
              PurchaseRejectionRef.value.resetForm(data);
            });

            addItem('Purchase Assign', () => {
              RoughIssueRef.value.resetForm(data);
            });
          }

          // if (canAddPieces) {
            addItem('Add Pieces', () => {
              const wt = data.inpr_wt || 0;
              const pcs = data.inpr_pcs || 0;

              if (wt > 0 || pcs > 0) {
                swal('Warning', 'Kapan weight is in process, can not stock !');
              } else {
                router.push('/purchase/update/' + btoa(data.id));
              }
            });
          // }

          menu.appendChild(content);
          dropdown.append(button, menu);

          return dropdown;
        }

      }
      ],

      renderComplete() {
        feather.replace({ 'stroke-width': 1.5 });
      },
    });


  }

  axios({
    url: 'api/kpn/grpt',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    data: params,
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.total = res.data.items
  })
}


// Reject Purchase
const cancel_process = async (id) => {

  swal({
    title: "Are you sure?",
    text: "You are about to Dactive purchase!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Reject",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => !$Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {

      const params = {
        id: (id != '' ? window.btoa(id) : ''),
        ip: localStorage.getItem('sk_key')
      }

      let promise_url = 'api/kpn/rp'
      let promise = axios({
        url: promise_url,
        method: "POST",
        data: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),

        },
        config: {
          headers: {
            Accept: "application/json"
          }
        }
      });
      return promise
        .then(result => result.data)
        .then(data => {

          if (data.status == 'error') {
            if (data.type && data.type == "warning") {
              cancel_process_confirm(params.id, data.message)
            } else {
              swal('Warning', data.message, 'warning');
            }
          } else {
            swal('Success', data.message, 'success');

            initTabulator()
          }
        })
        .catch(_error => {
          swal('Error', 'Something went wrong.', 'error');
        });

    }
  });
}
const cancel_process_confirm = async (id, mfg) => {

  swal({
    title: "Are you sure?",
    text: mfg,
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Confirm",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => !$Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {

      const params = {
        id: (id != '' ? window.btoa(id) : ''),
        ip: localStorage.getItem('sk_key')
      }

      let promise_url = 'api/kpn/rpc'
      let promise = axios({
        url: promise_url,
        method: "POST",
        data: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),

        },
        config: {
          headers: {
            Accept: "application/json"
          }
        }
      });
      return promise
        .then(result => result.data)
        .then(data => {

          if (data.status == 'error') {
            swal('Warning', data.message, 'warning');
          } else {
            swal('Success', data.message, 'success');

            initTabulator()
          }
        })
        .catch(_error => {
          swal('Error', 'Something went wrong.', 'error');
        });

    }
  });
}


const get_party_details = () => {

  axios({
    url: 'api/master/dp_parties',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.party_details = res.data.items
  })
}
const get_purchase_party_details = () => {

  axios({
    url: 'api/master/dp_purchase_parties',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.purchase_party_details = res.data.items

  })
}


const onResetFilter = () => {

  filter_data.status = '0'
  filter_data.kapan_no = ''
  filter_data.party_id = '0'
  filter_data.type = '0'
  filter_data.stone_id = '0'
}


const open_purchase_modal = () => {
  CreatePurchaseRef.value.resetForm();
}


function getStones() {
  axios({
    url: 'api/master/dp_stone',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.stones = res.data.items
  })
}

function getDiamondTypes() {
  axios({
    url: 'api/master/dp_diamond_type',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.diamond_type_items = res.data.items
  })
}

onMounted(() => {
  get_party_details()
  get_purchase_party_details()
  getStones()
  getDiamondTypes()
  initTabulator()
})
</script>
